import "./TestOrderLogsComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import commonService from "../../../../shared/services/common.service";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import LottieFileGenarationComponent
    from "../../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import {ImageConfig} from "../../../../constants";
import StatusCardComponent from "../../../../shared/components/status-card/statusCardComponent";
import ActivityLogTimelineComponent
    from "../../../../shared/components/activity-log-timeline/ActivityLogTimelineComponent";

interface TestOrderLogsComponentProps {
    testOrderId: any;
    onModeChange:Function;
}

const TestOrderLogsComponent = (props: TestOrderLogsComponentProps) => {
    const {testOrderId,onModeChange} = props;

    const [testOrderActivityLogs, setTestOrderActivityLogs] = useState<any>();

    const [testOrderActivityLogsLoading, setTestOrderActivityLogsLoading] = useState<boolean>();
    const [testOrderActivityLogsLoadingFailed, setTestOrderActivityLogsLoadingFailed] = useState<boolean>();
    const [testOrderActivityLogsLoaded, setTestOrderActivityLogsLoaded] = useState<boolean>();


    const getTestOrderActivityLogs = useCallback(() => {
        const payload = {};
        setTestOrderActivityLogsLoaded(false);
        setTestOrderActivityLogsLoading(true);
        setTestOrderActivityLogsLoadingFailed(false);
        commonService._testOrder.getTestOrderLogs(testOrderId, payload)
            .then((res: IAPIResponseType<any>) => {
                setTestOrderActivityLogs(res.data);
                setTestOrderActivityLogsLoaded(true);
                setTestOrderActivityLogsLoading(false);
                setTestOrderActivityLogsLoadingFailed(false);
            })
            .catch((err: any) => {
                setTestOrderActivityLogsLoaded(true);
                setTestOrderActivityLogsLoading(false);
                setTestOrderActivityLogsLoadingFailed(true);
            })
    }, [testOrderId])

    useEffect(() => {
        if (testOrderId) {
            getTestOrderActivityLogs();
        }
    }, [testOrderId,getTestOrderActivityLogs])

    useEffect(() => {
        onModeChange('view')
    }, [onModeChange]);

    return (
        <div className={'test-order-logs-component details-tab-data-wrapper'}>
            {
                testOrderActivityLogsLoading && <div className="h-v-center">
                    <LottieFileGenarationComponent
                        loop={true}
                        autoplay={true}
                        animationData={ImageConfig.LoadingLottieFile}/>
                </div>
            }
            {
                testOrderActivityLogsLoadingFailed && <>
                    <StatusCardComponent title={"TestOrder details failed to load"}/>
                </>
            }
            {
                testOrderActivityLogsLoaded && <>
                <div className="test-order-activity-logs-tab-wrapper details-tab-data-content">
                    <div className="details-tab-data-body">
                        <ActivityLogTimelineComponent logsData={testOrderActivityLogs}/>
                    </div>
                </div>
                </>
            }
        </div>
    );

};

export default TestOrderLogsComponent;